class VgTooltip extends HTMLElement {
	connectedCallback() {
		this.setup();
	}

	handleDropdownPosition() {
		const placeholderRect = this.placeholder.getBoundingClientRect();
		const dropdownRect = this.dropdown.getBoundingClientRect();

		const dropdownRightX = dropdownRect.x + dropdownRect.width;
		const placeholderRightX = placeholderRect.x + placeholderRect.width;
		const screenPadding = 10;
		
		if( (dropdownRect.x + dropdownRect.width) > window.innerWidth ) {
			this.dropdown.style.left = "auto";
			this.dropdown.style.right = "0";
			this.dropdown.style.transform = `translateX(${
				window.innerWidth - placeholderRightX - screenPadding
			}px)`;
		}

		if( (placeholderRect.y - dropdownRect.height) < 0 ) {
			this.dropdown.style.bottom = "auto";
			this.dropdown.style.top = placeholderRect.height + 5 + "px";
		}else{
			this.dropdown.style.top = "auto";
			this.dropdown.style.bottom = placeholderRect.height + 5 + "px";
		}
	}

	toggle() {
		if (this.isOpen()) {
			this.close();
		} else {
			this.open();
		}
	}

	isOpen() {
		return this.getAttribute("data-open") === "true";
	}

	open() {
		this.setAttribute("data-open", "true");
		this.handleDropdownPosition();
	}

	close() {
		this.removeAttribute("data-open");
	}

	setup() {
		this.placeholder = this.querySelector(".vg-tooltip__trigger");
		this.dropdown = this.querySelector(".vg-tooltip__panel");

		this.placeholder.addEventListener("mouseover", () => {
			document.dispatchEvent(new CustomEvent("vg-tooltip-hover", { detail: { content: this.dropdown } }, {passive: true} ));
			this.handleDropdownPosition();
		});
		this.placeholder.addEventListener("touchstart", () => {
			this.toggle();
			document.dispatchEvent(new CustomEvent("vg-tooltip-click", { detail: { content: this.dropdown } }, {passive: true} ));
		});
		this.placeholder.addEventListener("click", () => {
			document.dispatchEvent(new CustomEvent("vg-tooltip-click", { detail: { content: this.dropdown } } ));
		});
	}
}

function dismissAllTooltips(event) {
	if (typeof event.target.closest !== "function") return;
	const currentTooltip = event.target.closest("vg-tooltip");

	document
		.querySelectorAll('vg-tooltip[data-open="true"]')
		.forEach((tooltip) => {
			if (tooltip === currentTooltip) return;
			tooltip.close();
		});
}

customElements.define("vg-tooltip", VgTooltip);
document.addEventListener("touchstart", (e) => dismissAllTooltips(e), {passive: true});
